export default __webpack_public_path__ + "static/media/player_3_3.f8ccc4e8.png";